module.exports = "/static/assets/494de7de0b0bd52c632d519a96b00e24.png";